import { KEY_STAGE_FILTER_ORDER } from "./keyStageConstants";

const getKeyStageIndex = (value: string): number => {
  const index = KEY_STAGE_FILTER_ORDER.indexOf(value);
  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};

export const sortKeyStageOptions = <T extends { value: string }>(
  options: T[]
): T[] => {
  return [...options].sort(
    (a, b) => getKeyStageIndex(a.value) - getKeyStageIndex(b.value)
  );
};
